import dynamic from 'next/dynamic'
import clsx from 'clsx'

import Text from '~/components/Text/Text'

import styles from './MarkdownWithHeadline.module.sass'

// Optimization made to decrease first load JS.
const GenericContent = dynamic(() => import('~/components/GenericContent/GenericContent'))

export interface Props {
  headline: string
  markdownCode: string
}

const MarkdownWithHeadline: React.FC<Props> = ({ headline, markdownCode }) => {
  return (
    <div className={clsx('site-container site-grid', styles.section)}>
      <div className='col-span-2 md:col-span-6 md:col-start-2 lg:col-start-3 lg:col-span-8'>
        <Text variant='headline' fontSize={[55, 64, 105]} className={styles.headline}>
          {headline}
        </Text>
        <GenericContent code={markdownCode} />
      </div>
    </div>
  )
}

export default MarkdownWithHeadline
